import { Link } from "react-router-dom";
import { allNews, getWorkById } from "@/lib/content";

export default function NewsSection() {
  const [feature, ...rest] = allNews;
  const featureWork = getWorkById(feature.workId);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">热门影视资讯</h2>
            <p className="mt-2 text-sm text-foreground-600">及时追踪最新动态，掌握正在被讨论的影视话题。</p>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800 md:inline-flex">
            <i className="ri-refresh-line"></i>
            每日更新
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={featureWork ? `/detail/${featureWork.id}` : "/category"}
            className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-64 w-full overflow-hidden bg-background-200 md:h-80">
              <img
                src={feature.cover}
                alt={`${feature.title} 资讯配图`}
                title={`${feature.title} 影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                {feature.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {feature.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{feature.summary}</p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {feature.date}
                </span>
                <span className="flex items-center gap-1 text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.map((news) => {
              const work = getWorkById(news.workId);
              return (
                <Link
                  key={news.id}
                  to={work ? `/detail/${work.id}` : "/category"}
                  className="group flex gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-50/60"
                >
                  <div className="h-24 w-32 shrink-0 overflow-hidden rounded-lg bg-background-200 sm:h-28 sm:w-44">
                    <img
                      src={news.cover}
                      alt={`${news.title} 资讯配图`}
                      title={`${news.title} 影视资讯`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="text-xs font-medium text-accent-600">{news.category}</span>
                    <h3 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                      {news.title}
                    </h3>
                    <p className="mt-1.5 hidden text-xs leading-relaxed text-foreground-600 sm:line-clamp-2">{news.summary}</p>
                    <span className="mt-auto text-xs text-foreground-400">{news.date}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}